import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { GlobalService } from 'src/app/services/global/global.service';
@Component({
  selector: 'app-modal-redirect',
  templateUrl: './modal-redirect.component.html',
  styleUrls: ['./modal-redirect.component.scss'],
})
export class ModalRedirectComponent implements OnInit {
  constructor(
    public globalService: GlobalService,
    public dialogRef: MatDialogRef<ModalRedirectComponent>
  ) {}

  ngOnInit() {}

  close() {
    this.dialogRef.close();
  }
}
